import { CustomersAction, CustomersActionTypes, CustomersState } from "../types/customers"

const initialState: CustomersState = {
  customers: [],
  loading: false,
  error: null,
}

export const customersReducer = (state = initialState, action: CustomersAction): CustomersState => {
  switch (action.type) {
    case CustomersActionTypes.FETCH_CUSTOMERS_LIST:
      return {
        ...state,
        loading: true,
      }
    case CustomersActionTypes.FETCH_CUSTOMERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload,
      }
    case CustomersActionTypes.FETCH_CUSTOMERS_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
